import axios from "axios";
import { store } from "./redux/store/store";
import { setCurrentUser } from "./redux/user/user.actions";

export const initAuthSession = () => {
  const token = localStorage.getItem("token");
  const isGuest = localStorage.getItem("is_guest");
  console.log("🚀 initAuthSession", { token, isGuest });
  if (token) return;

  if (isGuest) {
    const guestUser = JSON.parse(localStorage.getItem("guest_user"));
    if (guestUser) {
      console.log("👤 Setting guest user to Redux:", guestUser);
      store.dispatch(setCurrentUser(guestUser));
    }
  }
};
